import styled from "styled-components";

export const SmsNotificationStyle = styled.div`
  .configurationCardWidth {
    width: 60vh !important;
  }

  .configurationCard {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 2vh 3.5vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 80vh;
    margin-bottom: 5vh;
    margin-top: 5vh;
    overflow-wrap: anywhere;
    justify-content: space-between;
    align-self: center;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }

  .form-button {
    width: 20vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 50px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
    align-self: center;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .field-div {
    display: flex;
    justify-content: end;
    margin-right: 5px;
    font-family: medium-pro, sans-serif;
  }

  .btn_view {
    display: flex;
    justify-content: space-between;
  }

  .table-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 10px;
    font-family: medium-pro, sans-serif;
  }

  .table-item2 {
    font-family: thin-pro, sans-serif;
  }
  .table-div2 {
    padding: 20px;
    width: 40%;
    display: flex;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .delete-icon {
    font-size: 1.2rem;
    color: #dd3e3e;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .table-loading {
    text-align: center;
    font-size: 1rem;
  }
`;
